import React from 'react';
import { Typography, Button, theme } from 'antd';
import { DollarOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;
const { useToken } = theme;

const BillingModule = () => {
  const { token } = useToken();

  return (
    <div style={{ textAlign: 'center', padding: '40px 0' }}>
      <DollarOutlined style={{ 
        fontSize: '64px', 
        color: token.colorPrimary, 
        marginBottom: '16px' 
      }} />
      <Title level={4} style={{ color: token.colorTextHeading }}>
        Billing Module
      </Title>
      <Text type="secondary" style={{ 
        maxWidth: '500px', 
        margin: '0 auto',
        fontSize: '15px'
      }}>
        Manage patient invoices, insurance claims, and payment processing.
      </Text>
      <Button 
        type="primary" 
        size="large" 
        style={{ 
          marginTop: '24px',
          borderRadius: '12px',
          fontWeight: 500
        }}
      >
        View Billing Dashboard
      </Button>
    </div>
  );
};

export default BillingModule;